/**
 * @fileoverview POST handler for the "/generative_ai/agent/clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentCloneCacheKeys } from "./constants";
import type { PostGenerativeAiAgentCloneProps, GenerativeAiAgentCloneResult } from "./types";

export const postGenerativeAiAgentClone = reactQueryMutationAdapter(
  generativeAiAgentCloneCacheKeys,
  (props: PostGenerativeAiAgentCloneProps): Promise<GenerativeAiAgentCloneResult> => {
    return fetch("/generative_ai/agent/clone", "POST", props);
  }
);
